
import { Either } from 'fp-ts/lib/Either';
import { apiRequest, ApiRequestFailure, HTTP_POST } from 'helpers/http';

export type DesignOnDesktopData = {
  email: string;
  /* PDP Url to link to in email */
  pdp: string;
  /* PDP Image Url to display in email*/
  pdpImage: string;
}

const magenumRequest = apiRequest(process.env.GATSBY_MAGENUM_BASE_URL);

export const sendDesignOnDesktopEmail = (body: DesignOnDesktopData): Promise<Either<ApiRequestFailure, boolean>> =>
  magenumRequest('email', 'design-on-desktop')(HTTP_POST)()<boolean>(body);
